import { useSelector } from 'react-redux';
import { IFullState } from 'src/types/All.type';

export default function IsDarkTheme() {
  const { isDark: isdark } = useSelector((state: IFullState) => state.Theme);

  return isdark === true;
}
